const iconsMap: Record<string, any> = {};
const context = require.context("!svg-react-loader!../../assets/icons", true, /\.svg$/);
context.keys().forEach((key) => {
  iconsMap[key.substr(2, key.length - 6)] = context(key);
});

export default iconsMap;
